import type { RowData } from '@tanstack/react-table';
import { isDateWithinRange } from '@/utility/date';
import type { Row } from '../appTable';

export const dateRange = <T extends RowData>(
  row: Row<T>,
  columnId: string,
  filterValue: { from?: string; to?: string }
) => {
  return isDateWithinRange(row.getValue(columnId), filterValue.from, filterValue.to);
};

export const arrayIncludes = <T extends RowData>(
  row: Row<T>,
  columnId: string,
  filterValue: string[]
) =>
  filterValue.some(
    (val: unknown) => (row.getValue(columnId) as number | string)?.toString() === val
  ) || filterValue.length === 0;

export const onProperty =
  (property: string) =>
  <T extends RowData>(row: Row<T>, columnId: string, filterValue: string[]) =>
    filterValue === (row.getValue(columnId) as Record<string, unknown>)[property];

export const includesStringInArray = <T extends RowData>(
  row: Row<T>,
  columnId: string,
  filterValue: string
) => {
  const value = row.getValue(columnId);
  if (value === null || value === undefined) return false;
  const searchLower = filterValue.toLowerCase();
  const stringValue = Array.isArray(value) ? JSON.stringify(value) : String(value);
  return stringValue.toLowerCase().includes(searchLower);
};
